import React from 'react'
import { TariffUpgradeType } from '../../methods/TariffUpgradeType'
import { ReactComponent as MarkIcon } from '../../images/pages/tariffsV2/mark.svg'
import { ReactComponent as PlusIcon } from '../../images/pages/tariffsV2/plus.svg'
import "pages/Styles/UpgradeTag.sass"

export type UpgradeLike = string | {
    upgrade_type?: string
    upgrade_id?: string
    upgrade_title?: string
    is_partial?: boolean
}

export function upgradeTypeOf(upgrade: UpgradeLike): string {
    if (typeof upgrade === 'string') {
        return upgrade
    }
    return upgrade.upgrade_type || upgrade.upgrade_id || ''
}

export function isPartialUpgrade(upgrade: UpgradeLike): boolean {
    return typeof upgrade === 'object' && Boolean(upgrade.is_partial)
}

export function upgradeTitleOf(upgrade: UpgradeLike): string {
    const type = upgradeTypeOf(upgrade)
    return TariffUpgradeType.getTitle(type as TariffUpgradeType) || type
}

interface PurchasedUpgradeTagProps {
    upgrade: UpgradeLike
    onPartialClick?: () => void
}

export function PurchasedUpgradeTag({ upgrade, onPartialClick }: PurchasedUpgradeTagProps) {
    const isPartial = isPartialUpgrade(upgrade)
    const title = upgradeTitleOf(upgrade)
    const clickable = isPartial && Boolean(onPartialClick)

    return (
        <div
            className={`upgrade-tag purchased${isPartial ? ' is-partial' : ''}${clickable ? ' is-clickable' : ''}`}
            onClick={clickable ? onPartialClick : undefined}
            role={clickable ? 'button' : undefined}
            tabIndex={clickable ? 0 : undefined}
            onKeyDown={clickable ? (event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault()
                    onPartialClick?.()
                }
            } : undefined}
            title={isPartial ? 'Действует не на весь баланс' : undefined}
        >
            <MarkIcon className="upgrade-icon" />
            <span className="upgrade-text">{title}</span>
            {isPartial && (
                <span className="upgrade-tag__warn" aria-label="Действует не на весь баланс">
                    !
                </span>
            )}
        </div>
    )
}

interface AvailableUpgradeTagProps {
    upgradeType: string
    onClick: () => void
}

export function AvailableUpgradeTag({ upgradeType, onClick }: AvailableUpgradeTagProps) {
    return (
        <div
            className="upgrade-tag available"
            onClick={onClick}
            role="button"
            tabIndex={0}
            onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault()
                    onClick()
                }
            }}
        >
            <PlusIcon className="upgrade-icon" />
            <span className="upgrade-text">
                {TariffUpgradeType.getTitle(upgradeType as TariffUpgradeType)}
            </span>
        </div>
    )
}

interface UpgradeTagsRowProps {
    children: React.ReactNode
}

export function UpgradeTagsRow({ children }: UpgradeTagsRowProps) {
    return (
        <div className="upgrade-tags-row">
            {children}
        </div>
    )
}
